import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useWebsocketConnection } from 'providers/WebsocketProvider'
import { useEffect } from 'react'

export interface Props {
  brandKitId: number
  onImageDescriptionsUpdate?: () => void
}

interface BrandVisualKitMessage {
  event: 'image_descriptions_updated'
  status: 'success' | 'failed'
  error?: string
}

export const useBrandVisualKitSubscription = ({ brandKitId, onImageDescriptionsUpdate }: Props) => {
  const websocketConnection = useWebsocketConnection()

  useEffect(() => {
    if (!websocketConnection) return

    const subscription = websocketConnection.subscriptions.create(
      { channel: 'BrandVisualKitChannel', brand_kit_id: brandKitId },
      {
        received: (message: BrandVisualKitMessage) => {
          if (message.event === 'image_descriptions_updated' && message.status === 'success') {
            onImageDescriptionsUpdate?.()
          }
          if (message.event === 'image_descriptions_updated' && message.status === 'failed') {
            showToastMessage('An error occurred! Our team has been notified and we are looking into it.', 'error')
          }
        },
      },
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [brandKitId, websocketConnection, onImageDescriptionsUpdate])
}
